<template>
  <div id="setmall">
    <div class="br-contentpanel" :data-min="false">
      <Header />
      <div class="br-pagebody pd-x-20 pd-sm-x-30">
        <div class="row">
          <div class="col-12">
            <div class="card card-body pd-25 bg-white">
              <div class="form-wrap">
                <h2>{{ $t("product.工艺编辑") }}</h2>
                <div class="form-row mg-b-15">
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.工艺名称") }}:<span class="tx-danger"
                      >*</span
                    >
                  </label>
                  <div class="col-4">
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model="name"
                    />
                  </div>
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.成本价格") }}:
                  </label>
                  <div class="col-4">
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-PRICE
                      v-model.number="price"
                    />
                  </div>
                </div>
                <div class="form-row mg-b-15">
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.生产时间") }}:
                  </label>
                  <div class="col-4">
                    <el-input size="small" v-model="duration" oninput="value=value.replace(/[^0-9]/g,'')"></el-input>
                  </div>
                </div>
              </div>
              <div class="form-wrap">
                <h2>{{ $t("product.备注信息") }}</h2>
                <div class="form-row mg-b-15">
                  <label
                    class="col-2 col-form-label form-control-sm text-right"
                  >
                    {{ $t("product.工艺描述：") }}
                  </label>
                  <div class="col-9">
                    <textarea
                      rows="3"
                      class="form-control form-control-sm"
                      v-model="desc"
                    ></textarea>
                  </div>
                </div>
                <div class="d-flex justify-content-center">
                  <a
                    class="btn btn-primary mg-r-25"
                    href="javascript:;"
                    @click="save"
                    >{{ $t("product.保存") }}</a
                  >
                  <a
                    class="btn btn-secondary"
                    href="javascrit:;"
                    @click="closeWin"
                    >{{ $t("product.返回") }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <api-loading :show="loading" class="drak"></api-loading> -->
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./header.vue"; //$t('product.头')

export default {
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //$t('product.左边栏$t('product.状态')')
      loading: true,
      id: this.$route.query.id ? this.$route.query.id : "",
      changeType: this.$route.query.changeType
        ? this.$route.query.changeType
        : "",
      info: null,
      name: "",
      price: "",
      duration: "",
      desc: "",
    };
  },
  components: {
    Header,
  },
  created(){
    this.getInfo()
  },
  methods: {
    getInfo(){
      if(this.id != ''){
        this.loading = true;
        $.api_call("api.SupplierProcess.getBySupplier", {id:this.id} ,(r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          console.log(r)
          let res = r.Data.Results
          this.name = res.name
          this.price = Number(res.price).toFixed(2)
          this.duration = res.productionDuration
          this.desc = res.desc
        } else {
          ShowTip(r.Message, "danger");
        }
      });
      }
    },
    save(){
      let url = ''
      this.loading = true;
      let params = {
        name: this.name,
        price: this.price,
        duration: this.duration,
        desc: this.desc,
      }
      if(this.id != '') {
        url = 'api.SupplierProcess.updateBySupplier'
        params.id = this.id
      } else {
        url = "api.SupplierProcess.addBySupplier"
      }
      $.api_call(url, params ,(r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          ShowTip(r.Message, 'success');
          this.closeWin()
        } else {
          ShowTip(r.Message, "danger");
        }
      });
    },
    closeWin() {
      this.$router.push({ path: "/storage-pro/" });
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.collapsed-menu .br-contentpanel {
  margin-left: 60px;
}
.form-wrap {
  position: relative;
  border: 1px #ddd solid;
  margin-bottom: 25px;
  padding: 25px;
  > h2 {
    position: absolute;
    top: -16px;
    left: 15px;
    z-index: 0;
    padding: 0 10px;
    background: #fff;
    line-height: 32px;
    font-weight: 700;
    font-size: 16px;
  }
}
.img-wrap {
  position: relative;
  width: 80px;
  height: 80px;
  background-size: cover;
  background-position: center;
  border: 1px #ddd solid;
  > a {
    position: absolute;
    right: 0;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    background-color: #dc3545;
    color: #fff;
    font-size: 12px;
  }
  > a:hover {
    background-color: #c82333;
  }
}
</style>
